/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CertificateCreateDto } from '../../models/certificate-create-dto';
import { CertificateDto } from '../../models/certificate-dto';

export interface CertificateAdminControllerCreateV1$Params {
      body: CertificateCreateDto
}

export function certificateAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: CertificateAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
  const rb = new RequestBuilder(rootUrl, certificateAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CertificateDto>;
    })
  );
}

certificateAdminControllerCreateV1.PATH = '/api/v1/certificates/admin';
